module.exports = __webpack_public_path__ + "static/media/Loan-dispute.e770fe1d.png";